<template>
  <div class="techs-container"
    v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true && detail && detail.technician">
    <div class="left-sidebar">
      <a :class="'left-sidebar__header active--' + infoActive" href=""
        @click.prevent="stockActive = 0; infoActive = 1; reapproActive = 0; ordersActive = 0;">
        <img src="/static/img/pictos/technicien.svg" class="">
        <span>{{ detail.technician.firstname }} {{ detail.technician.lastname }}</span>
      </a>
      <a :class="'left-sidebar__link left-sidebar__link--stock active--' + stockActive"
        @click.prevent="stockActive = 1; infoActive = 0; reapproActive = 0; ordersActive = 0;" href="">
        <span><strong>Stock</strong></span>
      </a>
      <a :class="'left-sidebar__link left-sidebar__link--reappro active--' + reapproActive"
        @click.prevent="stockActive = 0; infoActive = 0; reapproActive = 1; ordersActive = 0;" href="">
        <span><strong>Reappro</strong></span>
      </a>
      <a :class="'left-sidebar__link left-sidebar__link--orders active--' + ordersActive"
        @click.prevent="stockActive = 0; infoActive = 0; reapproActive = 0; ordersActive = 1;" href="">
        <span><strong>Commandes</strong></span>
      </a>
    </div>
    <div class="content-area">
      <backlink />
      <div class="content-area__title-container">
        <h1 v-if="infoActive == 1">Paramètres technicien</h1>
        <h1 v-if="stockActive == 1">Stock véhicule</h1>
        <h1 v-if="reapproActive == 1">Reappro paramétré</h1>
        <h1 v-if="ordersActive == 1">Commandes</h1>
        <input name="" value="" class="search__field" placeholder="Rechercher dans la liste" @keyup="searchFilter()"
          ref="keyword" v-if="stockActive == 1">
      </div>

      <div class="" v-if="infoActive == 1">
        <div class="stock-container">
          Valeur du stock : <strong> {{ detail.total_amount_vehicle }} €</strong>
        </div>

        <div class="info">
          <span class="info__name">Identifiant Gaïa : {{ detail.technician.id_gaia }}</span>
        </div>

        <div class="info">
          <img src="/static/img/pictos/mail.svg" class="info__picto">
          <span class="info__name">{{ detail.technician.email }}</span>
          <p class="info__secondary"></p>
        </div>

        <div class="info">
          <img src="/static/img/pictos/agence.svg" class="info__picto">
          <span class="info__name">{{ detail.technician.agency.name }}</span>
          <p class="info__secondary">Code imputation : <span class="bleu">{{ detail.technician.default_imputation ?
              detail.technician.default_imputation.code : null
          }}</span></p>
        </div>

        <div class="info">
          <img src="/static/img/pictos/codevehicule.svg" class="info__picto">
          <span class="info__name">{{ detail.technician.vehicle.name }}</span>
          <p class="info__secondary">Code véhicule : <span class="bleu">{{ detail.technician.vehicle.code }}</span></p>
        </div>

        <div class="data-container">
          <div class="data-container__left">
            <h2>Indisponibilités du technicien</h2>
            <div class="info" v-for="unavailability in detail.technician.unavailabilities">
              <img src="/static/img/pictos/indispo.svg" class="info__picto">
              <span class="info__name">du <strong>{{ unavailability.begin_date | moment('DD-MM-YYYY')
              }}</strong><br />au <strong>{{ unavailability.end_date | moment('DD-MM-YYYY') }}</strong></span>
              <p class="info__secondary">{{ unavailability.end_date | moment("diff", unavailability.begin_date,
                  'days') + 1
              }} jour(s)</p>
            </div>
          </div>
          <div class="data-container__right">
            <h2>Adresse de livraison du technicien</h2>
            <div class="info" v-for="address in detail.technician.addresses">
              <img src="/static/img/pictos/magasinstockssbulle.svg" class="info__picto">
              <span class="info__name">{{ address.street }} <br /> {{ address.zip_code }} {{ address.city }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="stock" v-if="stockActive == 1">
        <div class="stock__list">
          <ProductStock :item="item" v-for="item in filteredStock" v-if="item.stock > 0" :key="item.id"></ProductStock>
        </div>
      </div>
      <div class="reappro" v-if="reapproActive == 1">
        <div class="reappro__list">
          <ProductReapproParam :item="item" v-for="item in detail.vehicle_stocks" :key="item.id" :agent="true"
            v-if="item.restocking == 1"></ProductReapproParam>
        </div>
      </div>
      <div class="orders" v-if="ordersActive == 1">
        <div class="orders__list">
          <Order v-for="item in detail.orders" :item="item" :key="item.id"></Order>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Order from "@/components/Order/Order";
import ProductStock from "@/components/Product/ProductStock";
import ProductReapproParam from "@/components/Product/ProductReapproParam";

export default {
  name: "TechDetail",
  data() {
    return {
      detail: {
        id: null,
      },
      stockActive: 0,
      reapproActive: 0,
      ordersActive: 0,
      infoActive: 1,
      initialStock: [],
      filteredStock: [],
    };
  },
  components: {
    Order,
    ProductStock,
    ProductReapproParam
  },
  created() {
    this.$store.dispatch('showLoader');
  },
  computed: {

  },
  mounted() {
    const self = this;
    this.$store.dispatch('showLoader');

    this.$http.get('user/technician/'+this.$route.params.id, {

    }).then(function(response){
      self.detail = response.data;
      self.initialStock = self.detail.vehicle_stocks
      self.filteredStock = self.initialStock
      self.$store.dispatch('hideLoader');
    })
  },
  methods: {
    searchFilter(){
      let searched = event.target.value;
      const regex = new RegExp(searched.toLowerCase().replace(/\s/g, ".*"), "gi");
      this.filteredStock = this.initialStock.filter(vs => {
        if(vs.product.label.toLowerCase().match(regex) || vs.product.code.toLowerCase().match(regex)){
          return vs;
        }
     })
   },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.techs-container {
  display: flex;

}

.left-sidebar {
  width: 300px;

  &__header {
    background-color: $color4;
    display: flex;
    height: 300px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
      width: 100px;
      margin-left: 35px;
    }

    span {
      color: white;
      font-family: 'ClanFFBlack';
      font-size: 20px;
      margin-top: 25px;
      text-transform: uppercase;
    }

    &.active--1 {
      &:after {
        content: "";
        position: absolute;
        right: -10px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 0 10px 10px;
        border-color: transparent transparent transparent $color4;
      }
    }
  }

  &__link {
    height: 75px;
    display: flex;
    color: white;
    padding: 0 20px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      right: -10px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 10px 0 10px 10px;
    }

    &--stock {
      background-color: $vert;

      &.active--1 {
        &:after {
          border-color: transparent transparent transparent $vert;
        }
      }
    }

    &--reappro {
      background-color: $color4;

      &.active--1 {
        &:after {
          border-color: transparent transparent transparent $color4;
        }
      }
    }

    &--orders {
      background-color: $color2;

      &.active--1 {
        &:after {
          border-color: transparent transparent transparent $color2;
        }
      }
    }

    img {
      width: 20px;
    }

    span {
      color: white;
      font-size: 14px;

      strong {
        font-family: 'ClanProBold';
      }
    }

    &:hover {
      text-decoration: none;
    }
  }
}

.filters {
  position: absolute;
  top: 20px;
  right: 10px;

  .filter {
    border: 1px solid $grisclair;
    font-size: 12px;

    &:last-of-type {
      margin-left: 10px;
    }
  }
}

.content-area {
  width: calc(100% - 300px);
  padding: 0 5%;
  margin-top: 0;
  position: relative;

  &__title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 50px;

    h1 {
      flex: 1;
      font-family: 'ClanFFBlack';
      color: $color2;
      font-size: 25px;
      margin-bottom: 0;
      position: relative;
      padding-bottom: 30px;

      &:before {
        content: "";
        display: block;
        width: 60px;
        height: 8px;
        background-color: $color2;
        border-radius: 4px;
        position: absolute;
        bottom: 0;
      }
    }

    input {
      width: 350px;
      height: 35px;
      line-height: 35px;
      padding: 0 10px;
      font-size: 12px;
    }
  }

  .info {
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 40px;

    &__picto {
      width: 30px;
      margin-right: 30px;
    }

    &__name {
      font-family: 'ClanPro';
      color: $color1;
      font-size: 12px;
      width: 220px;

      strong {
        font-family: 'ClanProBold';
        font-weight: normal;
        font-size: 12px;
        display: block;
      }

      &--address {
        width: auto;
        flex: 1;
      }
    }

    &__btn {
      border: 1px solid $color2;
      color: $color2;
      text-align: center;
      height: 45px;
      line-height: 45px;
      padding: 0 20px;
      font-size: 12px;
      font-family: 'ClanProBold';
      font-weight: normal;
      width: 150px;

      &:hover {
        text-decoration: none;
      }
    }

    &__secondary {
      font-family: 'ClanPro';
      color: $grisfonce;
      font-size: 12px;
      margin-bottom: 0;

      span.bleu {
        color: $color1;
        font-family: 'ClanPro';
        font-size: 12px;
      }
    }
  }

  .stock-container {
    border: 1px solid $vert;
    height: 70px;
    display: inline-flex;
    padding: 0 80px;
    align-items: center;
    width: auto;
    font-family: 'ClanPro';
    color: $grisfonce;
    font-size: 12px;
    margin-bottom: 30px;

    strong {
      font-family: 'ClanFFBlack';
      color: $grisfonce;
      margin-left: 5px;
    }
  }

  .data-container {
    display: flex;
    width: 100%;

    h2 {
      font-family: 'ClanProBold';
      color: $color1;
      font-size: 14px;
      border-bottom: 1px solid $color3;
      padding-bottom: 5px;
      margin-bottom: 20px;
    }

    &__left,
    &__right {
      padding-right: 20px;
      width: 50%;

      .info {
        &__picto {
          margin-right: 20px;
          width: 20px;
        }

        &__name {
          width: auto;
          margin-right: 30px;

          strong {
            font-family: 'ClanProBold';
            font-weight: normal;
            display: inline;
          }
        }

        &__secondary {
          text-align: right;
        }
      }
    }
  }

  .reappro {
    &__list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .product {
        width: calc(50% - 10px);
        padding-bottom: 90px;
        margin-bottom: 20px;
      }
    }
  }

  .stock {
    &__list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .product {
        width: calc(50% - 10px);
        padding-bottom: 120px;
        margin-bottom: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/TechDetail.vue